import { Card, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';

import { Strings } from '@app/constants';
import { StyledTitle } from '@app/modules/dashboard/style';
import { DataNotFound, Scrollbar } from '@app/components';
import { InfoStatusCard } from '@app/components/card/info-status-card';
import { IAssets } from '@app/modules/assets';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { ITask } from '@app/modules/dashboard';

const EmployeeAssetsAndTasksPage = ({ data, remainingTaskData }: any) => {
  const navigate = useNavigate();
  return (
    <Stack flexDirection={{ sm: 'column', md: 'row' }} mb={3}>
      <Card
        sx={{
          width: { xs: '96%', md: '50%' },
          height: '300px',
          margin: '0 2% 0 2%',
          marginTop: { xs: '2%', sm: '2%', md: '0%' },
          borderRadius: '5px',
        }}
      >
        <StyledTitle>{Strings.dashboard.myRemainingTask}</StyledTitle>
        <Scrollbar sx={{ height: 250 }}>
          {remainingTaskData && remainingTaskData?.length > 0 ? (
            remainingTaskData.map((option: ITask) => (
              <InfoStatusCard
                key={option.id}
                titleName={option.name}
                subTitleHead={`${Strings.dashboard.assignedBy}:`}
                subTitleValue={`${option?.user?.firstName} ${option?.user?.lastName}`}
                status={option?.dueDates?.status}
                actionTime={option.dueDates?.endDate ? 'Due Date:' : undefined}
                actionSubValue={
                  option.dueDates?.endDate
                    ? dayjs(option.dueDates?.endDate).format('DD/MM/YYYY')
                    : ''
                }
                hideAvatar={true}
              />
            ))
          ) : (
            <DataNotFound height={230} />
          )}
        </Scrollbar>
      </Card>
      <Card
        sx={{
          width: { xs: '96%', md: '50%' },
          height: { md: '300px' },
          maxHeight: { xs: '300px' },
          margin: { xs: '0 2% 0 2%', sm: '0 2% 0 2%', md: '0 2% 0 0%' },
          marginTop: { xs: '2%', sm: '2%', md: '0%' },
          borderRadius: '5px',
        }}
      >
        <StyledTitle>{Strings.employeeDashborad.assets}</StyledTitle>
        <Scrollbar sx={{ height: { md: 250 }, maxHeight: { xs: 250 } }}>
          {data?.assets?.length > 0 ? (
            data?.assets?.map((option: IAssets) => {
              const openDetailsPage = () => {
                navigate(PATH_DASHBOARD.assetsDetail, { state: { id: option.id } });
              };
              return (
                <InfoStatusCard
                  key={option.id}
                  titleName={option.assetName}
                  subTitleHead={`${Strings.dashboard.assignedOn}:`}
                  subTitleValue={dayjs(option.createdAt).format('DD/MM/YYYY')}
                  status={option.status}
                  image={option.image}
                  onClick={openDetailsPage}
                />
              );
            })
          ) : (
            <DataNotFound height={230} />
          )}
        </Scrollbar>
      </Card>
    </Stack>
  );
};

export { EmployeeAssetsAndTasksPage };
